import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { locationRouting } from './location.routing';
import { SharedModule } from '../shared/shared.module';
import { LocationsFilterSheetComponent } from './shared';

import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { LocationComponent } from './location.component';
import { LocationIndexComponent } from './location/location-index.component';
import {LocationSaleListComponent} from './location-sale-list';
import {LocationSaleDetailsComponent} from './location-sale-details';
import {LocationSaleService, LocationSaleDetailsService} from './shared';


@NgModule({
    imports: [
        CommonModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        locationRouting,
        SharedModule,
    ],
    exports: [
        LocationComponent,
        LocationIndexComponent,
        LocationSaleListComponent,
        LocationSaleDetailsComponent,
        LocationsFilterSheetComponent
    ],
    declarations: [
        LocationComponent,
        LocationIndexComponent,
        LocationSaleListComponent,
        LocationSaleDetailsComponent,
        LocationsFilterSheetComponent
    ],
    providers: [LocationSaleService, LocationSaleDetailsService],
})
export class LocationModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/location.module.ts